<div class="p-4">
  <div class="general-box">
    <app-tab-menu-simple
      class="w-[-webkit-fill-available]"
      [tabs]="analyticsRouter"
      (changeSelected)="changeSelected($event.url ?? '', $event.indexSelected)"
      [titule]="'expired-portfolio.title' | translate"
    ></app-tab-menu-simple>
    <div class="lg:px-8 px-0 flex flex-col gap-y-7 w-full">
      <div class="flex flex-col gap-y-7 w-full">
        <div class="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          <app-input-general
            [formControlGeneral]="filter.get('filter')"
            [label]="'expired-portfolio.filterTable'"
            [placeholder]="'expired-portfolio.clients'"
          ></app-input-general>

          <div class="flex justify-end items-center gap-4 px-4 lg:col-start-3"></div>
        </div>

        <app-table-general-simple
          class="col-span-full"
          [dataSource]="dataSource"
          [headers]="headers"
          [subHeaders]="subHeaders"
          [isLoading]="loadService"
          [buttonEvent]="false"
          [hasExpansion]="true"
          (expandRow)="onActionButtonClick($event)"
        >
        </app-table-general-simple>

        <div
          class="flex flex-col lg:flex-row lg:justify-between items-center ml-4 my-4 col-span-full"
        >
          <mat-paginator
            [length]="listExpiredPortfolio?.totalCount || 0"
            [pageSize]="filter.value.pageSize || 10"
            (page)="onPageChange($event.pageIndex)"
            aria-label="Select page"
          >
          </mat-paginator>
        </div>
        <app-load-general [load]="loadService"></app-load-general>
      </div>
    </div>
  </div>
</div>
